import { Chip, makeStyles, TextField, Typography } from '@material-ui/core';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { validateEmail } from '../Utils/helper';
import { Toast } from '../Toast/Toast';

const useStyles = makeStyles(() => ({
  email__container: {
    background: '#fff',
    borderRadius: '10px',
    padding: '.5rem',
    border: '1px solid #DDE9FB',
    '& input': {
      fontSize: '13px',
      fontWeight: '600',
      lineHeight: '18px',
      color: '#545b7d',
      paddingLeft: '7px',
    },
  },
  email__chip__container: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
  },
  email__chip: {
    background: '#E7ECF4',
    '& .MuiChip-label': {
      fontWeight: '500',
      fontSize: '13px',
      lineHeight: '16px',
      color: '#545B7D',
    },
  },
  sectionTitle: {
    marginBottom: '17px',
    color: '#545B7D',
    fontSize: '13px',
    fontWeight: 'normal',
    lineHeight: '16px',
  },
  multiEmails: {
    marginBottom: '17px',
  },
  customCursor: {
    cursor: 'no-drop',
    '& .MuiInputBase-root': {
      cursor: 'no-drop',
    },
    '& .MuiInputBase-input': {
      cursor: 'no-drop',
    },
  },
  padding__top: {
    '& .MuiInputBase-input': {
      paddingTop: '1rem',
    },
  },
}));

const MultipleEmailFields = ({ disable, handleChangeFields, emails = '' }) => {
  const classes = useStyles();

  const [additionalEmails, setAdditionalEmails] = useState({
    enteredEmail: '',
    emails: [],
  });

  useEffect(() => {
    if (emails?.trim()) {
      setAdditionalEmails({
        ...additionalEmails,
        emails: emails?.split(',') || [],
      });
    }
  }, []);

  const onPressEnter = (e) => {
    const { key } = e;
    if (key === 'Enter') {
      setAdditionalEmails((prevState) => {
        if (validateEmail(prevState.enteredEmail)) {
          if (
            prevState.emails?.some(
              (y) => y?.trim() === prevState?.enteredEmail?.trim(),
            )
          ) {
            Toast('error', 'Same Email Already Exists!');
            return prevState;
          }

          const updatedEmails = [...prevState.emails, prevState.enteredEmail];

          // Call handleChangeFields with the latest valid emails
          handleChangeFields({
            target: {
              name: 'additionalEmails',
              value: updatedEmails.join(','), // Using comma-separated string
            },
          });

          // Return the updated state
          return {
            ...prevState,
            emails: updatedEmails,
            enteredEmail: '', // Clear input after adding valid email
          };
        }

        if (!validateEmail(prevState.enteredEmail)) {
          Toast('error', 'Invalid email entered');
          return prevState;
        }
      });
    }
  };

  const handleChangeEmail = (event) => {
    const { name } = event.target;
    let { value } = event.target;
    value = value?.trimStart();

    setAdditionalEmails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onRemoveEmail = (indx) => {
    if (disable) return;

    setAdditionalEmails((prevState) => ({
      ...prevState,
      emails: prevState.emails.filter((_, index) => index !== indx),
    }));
  };

  return (
    <div className={classes.multiEmails}>
      <div>
        <Typography className={classes.sectionTitle}>
          Add Additional Emails (For Sharing)
        </Typography>
      </div>
      <div>
        <TextField
          name='enteredEmail'
          disabled={disable}
          value={additionalEmails?.enteredEmail || ''}
          className={clsx(
            classes.email__container,
            disable && classes.customCursor,
            additionalEmails.emails.length > 0 && classes.padding__top,
          )}
          onKeyDown={(e) => onPressEnter(e)}
          onChange={handleChangeEmail}
          placeholder='Email'
          type='email'
          fullWidth
          InputProps={{
            disableUnderline: true,
            startAdornment: (
              <div className={classes.email__chip__container}>
                {additionalEmails.emails.map((tag, idx) => (
                  <Chip
                    key={tag}
                    className={classes.email__chip}
                    label={tag}
                    onDelete={() => onRemoveEmail(idx)}
                  />
                ))}
              </div>
            ),
            style: {
              display: 'flex',
              flexWrap: 'wrap',
            },
          }}
        />
      </div>
    </div>
  );
};

export default MultipleEmailFields;
